<template>
  <v-bottom-navigation
    background-color="#263238"
    horizontal
    grow
  >
    <div class="header">
      <div class="div-1">
        <a
          href="http://www.dbsystems.com.au"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-img
            :src="logo"
            width="100"
            height="50"
          />
        </a>
      </div>
      <div class="div-2">
        <span class="my-footer-style">
          DBSystems Pty Ltd | ABN 96 626 727 615.
        </span>
      </div>
    </div>
  </v-bottom-navigation>
</template>

<script>
export default ({
  name: 'AppFooter',
  data: () => ({
    value: 'recent',
    logo: require('@/assets/img/dbsLogoSmall.png'),
  }),
});
</script>
<style scoped>
.my-footer-style {
  color: #CFD8DC;
  font-family:'Times New Roman', Times, serif;
  font-weight: 600;
  font-size: 12px;
  margin-top: 15px;
}
.header {
  display: inline-block;
  width: 100%;
}
.div-1 {
  margin-top: 5px;
  float: left;
}
.div-2 {
  margin-top: 16px;
  float: right;
}
</style>
